export enum SubscriptionStatus {
  Active = 'active',
  Inactive = 'inactive',
  PendingActivation = 'pendingActivation',
  PendingDeactivation = 'pendingDeactivation',
}
